import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
/**
 * Cut-down version of DeclineBattleConfirmModal for cancelling your own
 * still-open lobby (see ArenaBattleOpenPost's "waiting" state) — same
 * underlying endpoint (DeclineBattleController, which branches on
 * ArenaBattle::isWaitingForOpponent() to skip the first-move check and the
 * opponent-notify step, since there's no opponent yet), but a plain
 * battleId is enough here (no ArenaBattle model needed, unlike CardSlider's
 * use of the other modal) and the copy doesn't reference a first move or a
 * second player being notified — neither applies before anyone has joined.
 */
export default class CancelOpenBattleConfirmModal extends Modal {
  loading = false;
  className() {
    return 'ArenaDeclineModal Modal--small';
  }
  title() {
    return m('[', null, m("i", {
      className: "fas fa-door-closed"
    }), " ", app.translator.trans('forumaker-arena.forum.battle_open.cancel_title'));
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "ArenaDeclineModal-text"
    }, app.translator.trans('forumaker-arena.forum.battle_open.cancel_confirm_text')), m("div", {
      className: "ArenaDeclineModal-actions"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      icon: "fas fa-door-closed",
      loading: this.loading,
      onclick: () => this.cancelBattle()
    }, app.translator.trans('forumaker-arena.forum.battle_open.cancel_confirm_btn')), m(Button, {
      className: "Button Button--block",
      disabled: this.loading,
      onclick: () => this.hide()
    }, app.translator.trans('forumaker-arena.forum.battle_open.cancel_cancel_btn'))));
  }
  async cancelBattle() {
    this.loading = true;
    m.redraw();
    try {
      await app.request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/arena/battles/${this.attrs.battleId}/decline`,
        errorHandler: () => {} // see ArenaProfilePage.tsx saveDeck()
      });
      this.hide();
      this.attrs.onCancelled?.();
    } catch {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('forumaker-arena.forum.battle_open.cancel_error'));
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/CancelOpenBattleConfirmModal', CancelOpenBattleConfirmModal);